import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { showToast } from "../ToastManager";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";

import AuthorizationService from '../../service/AuthorizationService';
import EmpresaCategoriaService from '../../service/EmpresaCategoriaService';

const empresaCategoriaService = new EmpresaCategoriaService(); // Create an instance of EmpresaService

const ListarCategoriaEmpresa = () => {
    const [categoria, setCategoria] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [loading1, setLoading1] = useState(false);
    const history = useHistory();
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [activeDialog, setActiveDialog] = useState(false);
    const [toDelete, setToDelete] = useState(null);
    const [toActive, setToActive] = useState(null);

    const iss = localStorage.getItem('iss');

    const initCategoria = useCallback(async () => {
        setLoading1(true);

        try {
            const data = await empresaCategoriaService.listCategoriaEmpresas(iss);
            setCategoria(data.data.rows);
        } catch (error) {
            console.error("Erro ao carregar categorias:", error);
            showToast({ severity: 'error', summary: 'Erro', detail: 'Erro ao carregar categorias' });
        } finally {
            setLoading1(false);
        }
    }, [iss]);

    const initFilters1 = () => {
        setFilters1({
            'nome': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
            'descricao': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        });
    }

    useEffect(() => {
        initFilters1();
        initCategoria();
    }, [initCategoria]);

    const irParaCadastro = () => {
        if (AuthorizationService.hasPermission('postEmpresaCategoria'))
            history.push('/empresa/categoria/cadastrar');
    }

    const abreModalDeletar = (tipo) => {
        setToDelete(tipo);
        setDeleteDialog(true);
    }

    const abreModalAtivar = (usuario) => {
        setToActive(usuario);
        setActiveDialog(true);
    }

    const handleDeleteTipo = () => {
        if (AuthorizationService.hasPermission('deleteCategoria')) {
            setLoading1(true)
            empresaCategoriaService.deleteCategoria(iss, toDelete.id).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: 'Tipo excluído com sucesso' });
                setLoading1(false);
                hideModalDeletar();
                initCategoria();
            });
        }
    }

    const handleActiveUsuario = () => {
        if (AuthorizationService.hasPermission('activeUser')) {
            setLoading1(true)
            let status = toActive.ativo ? 0 : 1;
            empresaCategoriaService.activeUser(iss, toActive.id, status).then(() => {
                showToast({ severity: 'success', summary: 'Sucesso', detail: `Usuario ${status ? 'ativado' : 'desativado'} com sucesso` });
                setLoading1(false);
                hideModalActive();
                initCategoria();
            });
        }
    }

    const editar = (tipoParaEditar) => {
        if (AuthorizationService.hasPermission('getEmpresaCategoria'))
            history.push('/empresa/categoria/editar/' + tipoParaEditar.id);
    }

    const hideModalDeletar = () => {
        setDeleteDialog(false);
        setToDelete(null);
    }

    const hideModalActive = () => {
        setActiveDialog(false);
        setToActive(null);
    }

    const statusBody = (rowData) => {
        return <Button icon={rowData.excluido ? 'pi pi-times' : 'pi pi-check'} onClick={() => { }} className="p-button-rounded  mr-2 mb-2" style={{ backgroundColor: rowData.excluido ? 'red' : 'green', color: 'black' }} />
        // return <i className={classNames('pi', { 'text-green-500 pi-check-circle': rowData.excluido, 'text-pink-500 pi-times-circle': !rowData.excluido })}></i>;
    }

    const opcoesBody = (rowData) => {
        return <span style={{ display: 'flex', justifyContent: 'space-between' }}>
            {AuthorizationService.hasPermission('deleteEmpresaCategoria') ? <Button icon="pi pi-trash" onClick={() => { abreModalDeletar(rowData) }} style={{ backgroundColor: 'red', borderColor: 'red' }} className="p-button-rounded mr-2 mb-2" /> : <></>}
            {AuthorizationService.hasPermission('getEmpresaCategoria') ? <Button icon="pi pi-pencil" onClick={() => { editar(rowData) }} className="p-button-rounded  mr-2 mb-2" /> : <></>}
        </span>
    }

    const deleteFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalDeletar} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteTipo} />
        </>
    );

    const activeDialogFooter = (
        <>
            <Button loading={loading1} label="Não" icon="pi pi-times" className="p-button-text" onClick={hideModalActive} />
            <Button loading={loading1} label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleActiveUsuario} />
        </>
    );

    return (
        <div className="grid table-demo">
            <div className="col-12">
                {AuthorizationService.hasPermission('postEmpresaCategoria') ? <Button label="Cadastrar" onClick={irParaCadastro} className="mr-2 mb-2"></Button> : <></>}
                <div className="card">
                    <h5>Categoria empresa</h5>
                    <DataTable value={categoria} paginator className="p-datatable-gridlines" showGridlines rows={10}
                        dataKey="id" filters={filters1} filterDisplay="menu" loading={loading1} responsiveLayout="scroll"
                        emptyMessage="Nenhuma agendamento cadastrado.">
                        <Column sortable field="nome" header="Tipo" filter filterPlaceholder="Procurar por tipo" style={{ minWidth: '12rem' }} />
                        <Column sortable field="descricao" header="Descrição" filter filterPlaceholder="Procurar por descrição" style={{ minWidth: '12rem' }} />
                        <Column sortable field="status" body={statusBody} header="Ativo" style={{ width: '1rem' }} />
                        <Column header="Opções" body={opcoesBody} style={{ width: '8rem' }} />
                    </DataTable>
                </div>
            </div>

            <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Deletar" modal footer={deleteFooter} onHide={hideModalDeletar}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja excluir a categoria selecionada?</span>
                </div>
            </Dialog>

            <Dialog visible={activeDialog} style={{ width: '450px' }} header="Ativar/Desativar" modal footer={activeDialogFooter} onHide={hideModalActive}>
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span>Tem certeza que deseja ativar/destivar o usuário selecionado?</span>
                </div>
            </Dialog>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(ListarCategoriaEmpresa, comparisonFn);
